// src/utils/waMessages.js — the line sent to the customer with the "order ready" / "delivered" WhatsApp messages.
// Staff can change these in Admin Panel → Settings → WhatsApp Messages; blank = use the default below.
export const DEFAULT_WA_MESSAGES = {
  readyDinein:   'Your order is ready and you can now collect the order from counter!',
  readyTakeout:  'Your order is ready. Please collect it from the counter! 🍕',
  readyDelivery: 'Your order is ready and our delivery partner will leave shortly! 🛵',
  delivered:     'Your order has been delivered. Enjoy your meal! 🍕 Thank you for choosing VIP Pizza.',
};

export const waMessage = (settings, kind, orderType) => {
  const key = kind === 'delivered' ? 'delivered'
    : orderType === 'dinein' ? 'readyDinein'
    : orderType === 'takeout' ? 'readyTakeout' : 'readyDelivery';
  const custom = settings?.['waMsg_' + key];
  return (typeof custom === 'string' && custom.trim()) ? custom.trim() : DEFAULT_WA_MESSAGES[key];
};